module.exports = {
    theme: {
        extend: {
            colors: {
                palette: {
                    'liz-blue': '#209EAD',
                    'liz-lightblue': '#B5E7EC',
                    'liz-teal': '#E9F8F9',
                    'liz-navy': '#31454D',
                    'liz-navy-dark': '#2B3840',
                    'liz-orange': '#FA702F',
                    'liz-yellow': '#FFDB0E',
                }
            },
            backgroundImage: {
                'gradient-radial': 'radial-gradient(var(--tw-gradient-stops))',
            },
        },
        fontFamily: {
            Onest: ['Onest', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
        require('tailwind-scrollbar'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
        __dirname + '/config/**/*.{vue,js,scss,php}',
    ],
};
